import React from "react";
const LabelField = ({ label, id }: any) => {
  return (
    // <label className={`${className} font-roboto`} htmlFor={id}>
    <label
      className=" font-roboto text-[14px] text-[#031B4E]  font-semibold mb-0 py-1"
      htmlFor={id}
    >
      {label} <span style={{ color: "red" }}></span>
    </label>
  );
};

export default LabelField;
